<template>
  <v-modal
    @hide-modal="$emit('hide-modal')"
    size="md"
  >
    <template v-slot:title>
      <h4>{{ product.name }}</h4>
    </template>
    <template v-slot:body>
      <form method="post" @submit.prevent="orderProduct">
        <div class="row">
          <div class="col-md-3">
            <img
              class="img-fluid"
              :src="product.image_url"
              :alt="product.name"
            />
          </div>
          <div class="col-md-9 text-muted">
            <small>{{ product.description }}</small>
          </div>
        </div>
        <hr/>
        <h5>{{ $t('phrase.order_information') }}</h5>
        <div class="text-muted"><small>{{ $t('sentence.fill_in_for_product') }}</small></div>

        <div class="mb-2">
          <v-text-input
            label="word.first_name"
            v-model="formData.first_name"
            :required="true"
          />
        </div>

        <div class="mb-2">
          <v-text-input
            label="word.infix"
            v-model="formData.infix"
          />
        </div>

        <div class="mb-2">
          <v-text-input
            label="word.last_name"
            v-model="formData.last_name"
            :required="true"
          />
        </div>

        <div class="mb-2">
          <v-text-input
            label="word.email"
            type="email"
            v-model="formData.email"
            :required="true"
          />
        </div>

        <v-form-errors
          :errors="formErrors"
        />

        <div class="d-flex justify-content-end">
          <v-button
            text="word.send"
            type="submit"
          />
        </div>
      </form>
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import FormErrors from '@/common/components/FormErrors.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { mapActions, mapGetters } from 'vuex';
import api from '@/common/api';
import { notify } from '@/common/utils/notify';

export default {
  name: 'ProductOrderModal',
  components: {
    'v-modal': Modal,
    'v-button': Button,
    'v-form-errors': FormErrors,
    'v-text-input': TextInput,
  },
  props: {
    product: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    ...mapActions(['refreshUser']),
    async orderProduct() {
      await api.post('product-orders/', this.formData);
      notify('phrase.order_success', 'sentence.order_success');
      this.$emit('hide-modal');

      await this.refreshUser();
      await this.$router.push({ name: 'reviewer-dashboard' });
    },
  },
  data() {
    return {
      formErrors: [],
      formData: {
        product_id: null,
        first_name: null,
        infix: null,
        last_name: null,
        email: null,
      },
    };
  },
  created() {
    this.formData.product_id = this.product.id;
    this.formData.first_name = this.user.profile.first_name;
    this.formData.infix = this.user.profile.infix;
    this.formData.last_name = this.user.profile.last_name;
    this.formData.email = this.user.username;
  },
};
</script>
